import { Box, CircularProgress, Link, LinkProps } from "@mui/material";
import { AxiosRequestConfig } from "axios";

import useAxios from "helpers/axios";

export interface IDownloadLink {
  requestConfig: AxiosRequestConfig;
  filename?: string;
  disabled?: boolean;
}

const useDownload = ({ requestConfig, filename }: IDownloadLink) => {
  const { fetchData, loading } = useAxios({ config: {}, callOnInit: false });
  const download = (config: AxiosRequestConfig = {}, fileName?: string) => {
    requestConfig = {
      ...requestConfig,
      ...config,
      ...{
        responseType: "blob",
      },
    };
    if (fileName) {
      filename = fileName;
    }
    fetchData(requestConfig, ({ response, responseHeaders }: any) => {
      const fName =
        filename ||
        getResponseFileName(responseHeaders) ||
        Math.random().toString(36).slice(2);
      const objectUrl = window.URL.createObjectURL(response);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.setAttribute("download", fName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  };

  const getResponseFileName = (headers: any): string | null => {
    let filename: string | null = null;
    const disposition = headers["content-disposition"];
    if (disposition) {
      const matches = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i.exec(
        disposition
      );
      if (matches && matches[2]) {
        filename = matches[2];
      }
    }
    return filename;
  };

  return { download, loading };
};

export const DownloadLink = ({
  requestConfig,
  filename,
  showProgress = true,
  disabled = false,
  ...props
}: LinkProps<"button"> &
  IDownloadLink & { showProgress?: boolean | number }) => {
  const { download, loading } = useDownload({ requestConfig, filename });
  return (<>
    <Link
      component="button"
      variant="body1"
      color="secondary"
      underline="always"
      type="button"
      onClick={() => download()}
      disabled={disabled}
      {...props}
    >
      {props.children}
    </Link>
    {showProgress && loading && (
      <Box
        width={20}
        height={20}
        position="absolute"
        right={0}
        top={0}
      >
        <CircularProgress
          size={typeof showProgress === "boolean" ? 20 : showProgress}
        />
      </Box>
    )}
  </>);
};

export default useDownload;
